import { useState, useEffect } from 'react'

function useFetch(url) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    fetch(url, { cache: 'no-store' })
      .then((r) => r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`))
      .then((d) => {
        if (cancelled) return
        setData(d)
        setLoading(false)
      })
      .catch((e) => {
        if (cancelled) return
        setError(String(e))
        setLoading(false)
      })
    return () => { cancelled = true }
  }, [url])

  return { data, loading, error }
}

export function useInsights({ weekOf } = {}) {
  const url = weekOf ? `/api/insights?week_of=${weekOf}` : '/api/insights'
  const { data, loading, error } = useFetch(url)

  return {
    buckets: data?.buckets ?? { inflection: [], capital_flow: [], earnings_tells: [], quiet_signals: [] },
    latest: data?.latest ?? [],
    meta: data?.meta ?? null,
    loading,
    error,
  }
}
